import Checkbox from '@mui/material/Checkbox';
import FormControlLabel from '@mui/material/FormControlLabel';
import InputAdornment from '@mui/material/InputAdornment';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import { Search } from 'lucide-react';

import { DevelopmentStatusFilter } from '@/presentation/pages/developments/components/development-status-filter.js';

interface DevelopmentListFiltersProps {
    search: string;
    onSearchChange: (value: string) => void;
    statusFilter: string[];
    onStatusFilterChange: (value: string[]) => void;
    showCanceled: boolean;
    onShowCanceledChange: (value: boolean) => void;
    translate: (key: string, opts?: Record<string, unknown>) => string;
    statuses: readonly string[];
}

export function DevelopmentListFilters({
    search,
    onSearchChange,
    statusFilter,
    onStatusFilterChange,
    showCanceled,
    onShowCanceledChange,
    translate,
    statuses
}: DevelopmentListFiltersProps) {
    return (
        <Stack direction="row" spacing={2} sx={{ mb: 2 }}>
            <TextField
                placeholder={translate('devList.searchPlaceholder')}
                value={search}
                onChange={(e) => onSearchChange(e.target.value)}
                size="small"
                sx={{ flex: 1 }}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <Search size={16} />
                        </InputAdornment>
                    )
                }}
            />
            <DevelopmentStatusFilter value={statusFilter} onChange={onStatusFilterChange} translate={translate} statuses={statuses} />
            <FormControlLabel
                control={<Checkbox checked={showCanceled} onChange={() => onShowCanceledChange(!showCanceled)} data-testid="toggle-show-canceled" size="small" />}
                label={translate('devList.showCanceled')}
            />
        </Stack>
    );
}
